import isEqual from 'react-fast-compare';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, import/prefer-default-export
export const compareKeys = <TSelected extends Record<string, any>>(
  a: TSelected | undefined,
  b: TSelected | undefined,
  options?: {
    excludeKeys: (keyof NonNullable<TSelected>)[];
  },
) => {
  // to compare null vs undefined
  // eslint-disable-next-line eqeqeq
  if (a == b) {
    return true;
  }

  if (a == null || b == null) {
    return false;
  }

  const excludedKeys = options?.excludeKeys ?? [];
  const keysToUse = [...new Set([...Object.keys(a), ...Object.keys(b)])].filter(
    (key) => !excludedKeys.includes(key),
  );

  for (const key of keysToUse) {
    if (a[key] !== b[key] && !isEqual(a[key], b[key])) {
      return false;
    }
  }

  return true;
};
